module.exports = __webpack_public_path__ + "static/media/icon_help.6325449d.svg";